import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propNumber, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import RightComponentComment from './RightComponentComment';
import RightComponentPcCharmPoint from './RightComponentPcCharmPoint';
import RightComponentSpCharmPoint from './RightComponentSpCharmPoint';
const RightComponent = (props) => {
    const { charmPoint, charmPoints, confirmComment, driverOfPdfTargetOneRef, goodPointComment, isDisabled, onChangeCompleteInputRange, onChangeInputRange, onClickDriverOfPdfTarget, } = props;
    return (_jsxs("div", Object.assign({ className: 'action_column' }, { children: [_jsx(RightComponentPcCharmPoint, { charmPoint: charmPoint, charmPoints: charmPoints, driverTargetRef: driverOfPdfTargetOneRef, isDisabled: isDisabled, onChangeCompleteInputRange: onChangeCompleteInputRange, onChangeInputRange: onChangeInputRange, onClickDriverTarget: onClickDriverOfPdfTarget }), _jsx(RightComponentSpCharmPoint, { charmPoint: charmPoint, charmPoints: charmPoints, isDisabled: isDisabled, onChangeCompleteInputRange: onChangeCompleteInputRange, onChangeInputRange: onChangeInputRange }), (goodPointComment || confirmComment) && (_jsx(RightComponentComment, { confirmComment: confirmComment, goodPointComment: goodPointComment }))] })));
};
RightComponent.propTypes = {
    charmPoint: propNumber().isRequired,
    charmPoints: propArrayShape().isRequired,
    confirmComment: propStr().isRequired,
    driverOfPdfTargetOneRef: propShape(),
    goodPointComment: propStr().isRequired,
    isDisabled: propBool().isRequired,
    onChangeCompleteInputRange: propFunc().isRequired,
    onChangeInputRange: propFunc().isRequired,
    onClickDriverOfPdfTarget: propFunc(),
};
RightComponent.defaultProps = {
    driverOfPdfTargetOneRef: null,
    onClickDriverOfPdfTarget: undefined,
};
export default RightComponent;
